import { action, makeAutoObservable, observable } from "mobx";
var NotificationStore = /** @class */ (function () {
    function NotificationStore() {
        Object.defineProperty(this, "message", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ""
        });
        Object.defineProperty(this, "heading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ""
        });
        Object.defineProperty(this, "showOkButton", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "visible", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "notification"
        });
        makeAutoObservable(this, {
            message: observable,
            visible: observable,
            type: observable,
            showOkButton: observable,
            heading: observable,
            showNotification: action,
            clearNotification: action,
        });
    }
    Object.defineProperty(NotificationStore.prototype, "showNotification", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value) {
            var _this = this;
            this.message = value.message;
            this.visible = value.visible;
            this.type = value.variant;
            this.heading = value.heading || "";
            this.showOkButton = value.showOkButton || false;
            if (this.visible && !this.showOkButton) {
                setTimeout(function () {
                    _this.clearNotification();
                }, 10000);
            }
        }
    });
    Object.defineProperty(NotificationStore.prototype, "clearNotification", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.visible = false;
            this.message = "";
            this.heading = "";
            this.showOkButton = false;
        }
    });
    return NotificationStore;
}());
export default NotificationStore;
